import type { ChecklistAnswerOption, ChecklistQuestion } from './types';

export function makeTempQid() {
  return `temp_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function normalizeAnswers(
  type: ChecklistQuestion['type'],
  answers?: ChecklistAnswerOption[]
) {
  if (type !== 'single' && type !== 'multi') return [];
  return (answers ?? [])
    .map((a) => ({
      value: (a.value ?? '').trim(),
      label: (a.label ?? '').trim() || (a.value ?? '').trim(),
    }))
    .filter((a) => a.value.length > 0);
}

export function reindexAnswers(answers: ChecklistAnswerOption[]) {
  return answers.map((a, idx) => ({
    ...a,
    value: String(idx + 1),
  }));
}
